export const UserAPIEndpoint = {
  Users: "api/v1/users",
  Me: "api/v1/users/me",
  Add: "api/v1/users/add-friend",
  Status: "api/v1/users/status-friend",
  Friends: "api/v1/users/friends",
  Find: "api/v1/users/find",
  Update: "api/v1/users/update",
  UpdateGroupPrefer: "api/v1/users/group-preference",
  Checkin: "api/v1/users/checkin",
  GetUserCheckin: "api/v1/users/get/checkin",
  Cancel: "api/v1/users/cancel-friend",
  MyGroups: "api/v1/users/all-groups",
  AcceptFriend: "api/v1/users/accept-friend",
  NearBy: "api/v1/users/near-by",
  Requested: "api/v1/users/all/requested",
  PendingAccept: "api/v1/users/all/pending-accept",
  GetGroupPrefer: "api/v1/users/get/group-preference",
  PublicProfile: "api/v1/users/detail",
  BlockFriend: "api/v1/users/block-friend",
  UnBlockFreind: "api/v1/users/unblock-friend",
  GetBlockAccount: "api/v1/users/all/block-account",
  CheckBlockedAccount: "api/v1/users/check/blocked",
};
